import {useState} from "react"
import MusicWaveform from "./MusicWaveform"
import UploadMusic from "./UploadMusic"



const MusicEditor = (props) => {
    const [fileURL, setFileURL] = useState(null)

    return (
        <>
            {!fileURL ?
                <UploadMusic fileURL={fileURL} setFileURL={setFileURL} setBaseObject={props.setBaseObject} baseObject={props.baseObject} /> 
                : 
                <MusicWaveform fileURL={fileURL} setFileURL={setFileURL} setBaseObject={props.setBaseObject} baseObject={props.baseObject} />
            }
        </>
    )
}

export default MusicEditor